import React, { useState, useEffect } from 'react';
import '../styles/LoadingSpinner.css';

const loadingMessages = [
  "Configurator opstarten...",
  "3D omgeving laden...",
  "Materialen voorbereiden...",
  "Texturen laden...",
  "Houtstructuren verwerken...",
  "Kleuren initialiseren...",
  "Belichting instellen...",
  "Camera positioneren...",
  "Schaduwen berekenen...",
  "Details verfijnen...",
  "Laatste optimalisaties...",
  "Bijna klaar..."
];

export const LoadingSpinner = ({ message }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    // Cycle through messages every 1200ms
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 1200);

    return () => clearInterval(interval);
  }, []);

  const displayMessage = message || loadingMessages[currentMessageIndex];

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="logo-container">
          <svg width="100" height="112" viewBox="0 0 487.59 547.21" className="logo-svg">
            <defs>
              <style>
                {`.logo-path { fill: #f3f4f6; }`}
              </style>
            </defs>
            {/* Roof - animates first */}
            <path className="logo-path logo-part-1" d="m487.59,243.8v48.73L243.8,48.73,0,292.52v-48.73c0-12.93,5.14-25.33,14.28-34.48L209.32,14.28c19.04-19.04,49.91-19.04,68.96,0l195.04,195.04c9.14,9.14,14.28,21.55,14.28,34.48Z"/>

            {/* Walls - animate second */}
            <g className="logo-part-2">
              <path className="logo-path" d="m115.97,498.44l48.76,48.76H48.76c-26.93,0-48.76-21.83-48.76-48.76v-136.95l48.76-48.76v185.71h67.21Z"/>
              <path className="logo-path" d="m487.59,361.49v136.95c0,26.93-21.83,48.76-48.76,48.76h-115.97l48.76-48.76h67.21v-185.71l48.76,48.76Z"/>
            </g>

            {/* Center detail - animates last */}
            <path className="logo-path logo-part-3" d="m226.55,143.56l-122.95,122.98v68.93l140.19-140.19,140.19,140.23v-68.96l-122.95-122.98c-9.52-9.52-24.96-9.52-34.48,0Zm17.24,344.78l-140.19-140.15v68.93l122.95,122.95c9.52,9.52,24.96,9.52,34.48,0l122.95-122.95v-68.97l-140.19,140.19Z"/>
          </svg>
        </div>
        <p className="loading-text">{displayMessage}</p>
      </div>
    </div>
  );
};
